type Callback<E extends Event> = (event: E) => unknown;

interface EventDispatcher<O, T, E extends Event> {
    addEventListener(type: T, callback: Callback<E>, options?: O): unknown;
    removeEventListener(type: T, callback: Callback<E>): unknown;
};

/**
 * Remove and then add the given event listener to the given event dispatcher.
 *
 * This is generic but shouldn't need explicit type parameters when it's used;
 * the hope is that it will simply pass the types through to the element it is
 * called with, which will then do the type checking. Not sure it's really
 * working though.
 */
export const registerListener = <O, T, E extends Event>
    (elt: EventDispatcher<O, T, E>,
     type: T,
     callback: Callback<E>,
     options?: O) =>
{
    elt.removeEventListener(type, callback);
    elt.addEventListener(type, callback, options);
}
export default registerListener;
